var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLdo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6643_36912)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6643_36912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12C0 5.376 5.376 0 12 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6643_36912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 24M24 0L0 24",
    stroke: "black",
    strokeMiterlimit: 22.9256
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12C0 5.376 5.376 0 12 0Z",
    fill: "url(#paint0_linear_6643_36912)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6643_36912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 14,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9905 14.1312L6.64334 11.0784L6.49934 11.2992C4.85774 13.824 5.22254 17.1264 7.38254 19.248C9.92654 21.744 14.0545 21.744 16.5985 19.248C18.7585 17.1264 19.1233 13.824 17.4817 11.2992L17.3377 11.0784L11.9905 14.1312Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6643_36912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9906 21.3119C15.5906 21.3119 18.509 18.3936 18.509 14.7935C18.509 11.1935 15.5906 8.27515 11.9906 8.27515C8.39056 8.27515 5.47217 11.1935 5.47217 14.7935C5.47217 18.3936 8.39056 21.3119 11.9906 21.3119Z",
    fill: "url(#paint1_radial_6643_36912)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9903 7.31519L7.38232 9.94559L11.9903 12.576L16.5983 9.94559L11.9903 7.31519Z",
    fill: "url(#paint2_radial_6643_36912)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.99683L6.64307 11.0784L11.9903 14.1312L17.3279 11.0784L11.9999 7.99683Z",
    fill: "url(#paint3_radial_6643_36912)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9903 2.87988L7.38232 9.94548L11.9903 12.5759V2.87988Z",
    fill: "url(#paint4_linear_6643_36912)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9902 12.5759L16.5982 9.94548L11.9902 2.87988V12.5759Z",
    fill: "url(#paint5_linear_6643_36912)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6643_36912",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C882"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6643_36912",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9783 20.1289) rotate(-90.4664) scale(8.705 10.3758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7985AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6643_36912",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9903 9.94559) scale(0.2304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2FF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6643_36912",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9855 11.064) scale(0.268877)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE6F9",
    stopOpacity: 0.8588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6643_36912",
    x1: 9.68632,
    y1: 2.39988,
    x2: 9.68632,
    y2: 11.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93D6F2",
    stopOpacity: 0.898
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6643_36912",
    x1: 14.2942,
    y1: 2.39988,
    x2: 14.2942,
    y2: 11.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#506AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96CFEF",
    stopOpacity: 0.8196
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6643_36912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdo);
export default __webpack_public_path__ + "static/media/ldo.9f4f6f640bee2ca3315f2018cc022e9c.svg";
export { ForwardRef as ReactComponent };